import { render, staticRenderFns } from "./RegisterDBP.form.vue?vue&type=template&id=3c4f3850&scoped=true&lang=pug&"
import script from "./RegisterDBP.form.vue?vue&type=script&lang=ts&"
export * from "./RegisterDBP.form.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterDBP.form.vue?vue&type=style&index=0&id=3c4f3850&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4f3850",
  null
  
)

export default component.exports